// Rotta per ciascuna voce della coda di lavoro (dashboard): click → pagina GIÀ
// filtrata sull'elemento/stato della voce (query param letti all'init dalla
// pagina di destinazione e riflessi nei controlli filtro, così l'utente vede e
// può togliere il filtro).
export const ROUTE_BY_CHIAVE: Record<string, string> = {
  richieste_ricevute: '/richieste?status=ricevuto',
  consultazioni_rt: '/richieste?status=in_consultazione&consultazione_tipo=RT',
  consultazioni_dir: '/richieste?status=in_consultazione&consultazione_tipo=DIR',
  conferimenti_attesa_compliance: '/programmazione?view=list&status=attesa_compliance',
  conferimenti_in_ritardo: '/programmazione?view=list&status=in_ritardo',
  da_fatturare_attive: '/fatturazione?sezione=attive',
  da_registrare_passive: '/fatturazione?sezione=passive',
  uscite_da_registrare_ecomatico: '/uscite?ecomatico=da_registrare',
  omologhe_in_scadenza: '/produttori?omologhe=in_scadenza',
};
